import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../../styles/JourneyRightSection/responsive.css";
// * Icons
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// * Images
import YouindiLogo from "../../../imagesLogo/youindiLogo.png";
// * Components
import OtpInputField from "../../DataInputFields/OtpInputField/OtpInputField";
import ContinueButton from "../../Buttons/SlideContinueButton/ContinueButton";
// ** Micro Components
import PowerdByRoopya from "../../../components/PowerdByRoopya/PowerdByRoopya";
// * Application Error Handling Context
import ErrorContext from "../../../context/ErrorProvider";
import CustomerContext from "../../../context/CustomerContext";
// * Utils
import * as Errors from "../../../utils/errors";
// * API Handler
import { useMutation } from "@tanstack/react-query";
// * APIs
import { resendOTP } from "../../../api/services/Journey";
import { CONTACT_ID, Authorization_TOKEN } from "../../../constants";

export default function OTPSlide({
  mobileNumber,
  setActiveSlide,
  handleOtp,
  verifyOTP,
  verifyOTPLoading,
  otpRefKey1,
  otpRefKey2,
  otpRefKey3,
  otpRefKey4,
  orgLogoData,
  ContactID,
  TokenForCustomers,
}) {
  // * API Key and API Secret
  const { apiKey, apiSecret } = useParams();

  // * State to handle journey error
  const { error } = useContext(ErrorContext);
  const { customerDetails } = useContext(CustomerContext);
  console.log("orgLogoData",orgLogoData)
  const [timer, setTimer] = useState(30);
  const [isResending, setIsResending] = useState(true);

  useEffect(() => {
    otpRefKey1?.current?.focus();
  }, [otpRefKey1.current]);

  useEffect(() => {
    let countdownInterval;

    if (isResending) {
      if (timer > 0) {
        countdownInterval = setInterval(() => {
          setTimer((prevTimer) => prevTimer - 1);
        }, 1000);
      } else {
        setIsResending(false);
        setTimer(60);
        clearInterval(countdownInterval);
      }
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [timer, isResending]);

  const resendOTPAPI = useMutation({
    mutationKey: ["resendOTP"],
    mutationFn: (Payload) =>
      resendOTP(Payload).then(() => setIsResending(true)),
    retry: false,
  });

  const handleResendOTP = () => {
    const otpResendData = {
      // id: CONTACT_ID ,
      id: customerDetails.contactId,
    };
    const headers = {
      // Authorization: `Bearer ${Authorization_TOKEN || ""}`,
      Authorization: `Bearer ${customerDetails[Authorization_TOKEN] || ""}`,
    };
    const Payload = {
      payload: otpResendData,
      headers: headers,
    };

    // resendOtp("text");
    resendOTPAPI.mutate(Payload);
  };

  return (
    <div>
      <div className="logoBox">
        <img
          // style={{ margin: "0 auto", width: "225px", marginTop: "10px" }}
          //src={YouindiLogo}
          src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
        />
      </div>
      <div className="carouselSlideWrapper otpSlideWrapper">
        {/* <img style={{height: 30, width: 110, paddingTop:10}} src={YouindiLogo}/> */}
        {/* OTP Instructions */}
        <div className="typographyContainer">
          <h1 sx={{ textAlign: "left" }}>Just a small check!</h1>
          <div className="otpReceiverDetails">
            <p>We have sent the OTP to +91 {mobileNumber}</p>
            <button
              className="mobileEditBtn"
              onClick={() => setActiveSlide((currentSlide) => currentSlide - 1)}
            >
              <EditRoundedIcon
                className="editBtnIcon"
                style={{ fontSize: "15px" }}
              />
              Edit
            </button>
          </div>
        </div>

        {/* OTP Input Fields */}
        <div className="otpInputFieldsContainer">
          <div className="otpInputFields">
            <OtpInputField
              reference={otpRefKey1}
              error={error}
              tabIndex={1}
              errorType={Errors.OTP_ERROR_TYPE}
              // onEnterHandler={verifyOTP}
              handler={(otpKey) => handleOtp(otpKey, otpRefKey1)}
            />
            <OtpInputField
              reference={otpRefKey2}
              error={error}
              tabIndex={2}
              errorType={Errors.OTP_ERROR_TYPE}
              // onEnterHandler={verifyOTP}
              handler={(otpKey) => handleOtp(otpKey, otpRefKey2)}
            />
            <OtpInputField
              reference={otpRefKey3}
              error={error}
              tabIndex={3}
              errorType={Errors.OTP_ERROR_TYPE}
              // onEnterHandler={verifyOTP}
              handler={(otpKey) => handleOtp(otpKey, otpRefKey3)}
            />
            <OtpInputField
              reference={otpRefKey4}
              error={error}
              tabIndex={4}
              errorType={Errors.OTP_ERROR_TYPE}
              // onEnterHandler={verifyOTP}
              handler={(otpKey) => handleOtp(otpKey, otpRefKey4)}
            />
          </div>

          {error.error && error.type === Errors.OTP_ERROR_TYPE ? (
            <div className="errorBox">
              <ErrorOutlineRoundedIcon style={{ fontSize: "14px" }} />
              <p>{error.message}</p>
            </div>
          ) : null}
          <div className="resendOtpBtnBox">
            {isResending ? (
              <div className="timerBox">
                <p>Resend OTP in {timer} seconds</p>
              </div>
            ) : (
              <button
                className="resendOtpBtn"
                onClick={handleResendOTP}
                disabled={resendOTPAPI.isLoading}
              >
                {resendOTPAPI.isLoading ? "Resending..." : "Resend OTP"}
              </button>
            )}

            {error.error && error.type === "resendOtpError" ? (
              <div className="otpResendError">
                <ErrorOutlineRoundedIcon
                  style={{ fontSize: "15px", color: "red" }}
                />
                <p>{error.message}</p>
              </div>
            ) : null}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            paddingTop: "5%",
            justifyContent: "center",
          }}
        >
          <CheckCircleIcon style={{ color: "#00AF54" }} />{" "}
          <div
            style={{
              fontSize: 12,
              paddingTop: 4,
              marginLeft: 10,
            }}
          >
            I Agree to Privacy policy and Terms and Conditions.
          </div>
        </div>

        <div className="verifyOtpBtnContainer">
          <ContinueButton
            tabIndex={5}
            loading={resendOTPAPI.isLoading || verifyOTPLoading}
            handler={verifyOTP}
            // handler={() => setActiveSlide((prev) => prev + 1)}
          />
        </div>

        <div className="tncCheckBox">
          <PowerdByRoopya />
        </div>
      </div>
    </div>
  );
}
